import React, { Fragment } from 'react';
import { Box, Divider, Grid, ListItemText, Typography, Skeleton } from '@mui/material';
import styled from '@emotion/styled';
import ActiveChip from './ActiveChip';
import { useNavigate } from 'react-router-dom';



const TaskContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    marginTop: theme.spacing(2),
    height: '100%',
}));

const BoxTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(3),
}));

const DataSet = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxHeight: '2000px',
    paddingRight: theme.spacing(1),
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
        width: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.light,
        borderRadius: '4px',
    },
    '&::-webkit-scrollbar-button': {
        display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
        border: `0px`,
        padding: theme.spacing(1, 0),
        minHeight: theme.spacing(0),
    }
}));

const DataSetItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));

const DatasetItemAccount = styled(ListItemText)(({ theme }) => ({
    color: theme.palette.text.primary,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
}));

const DataDivider = styled(Divider)(({ theme }) => ({
    width: '100%',
}));

const ProfileAccountsBox = ( {accounts=[], isLoading=true} ) => {
    const navigate = useNavigate();

    return (
        <Grid item xs={12} md={4} lg={4}>
            <TaskContainer>
                <BoxTitle variant="h5">Accounts</BoxTitle>
                <DataSet>
                    {isLoading ? <><Skeleton width={100} height={20} /> <DataDivider /> <Skeleton width={100} height={20} /> <DataDivider /> <Skeleton width={100} height={20} /> <DataDivider /> <Skeleton width={100} height={20} /></> : (
                        accounts.map((item, index) => (
                            <Fragment key={index}>
                                <DataSetItem>
                                    <DatasetItemAccount 
                                    primary={item.account.name} 
                                    secondary={item.role}
                                    primaryTypographyProps={{ component: "a", style: { cursor: 'pointer' }, onClick: () => navigate(`/account/${item.account.slug}`) }}
                                    secondaryTypographyProps={{ variant: 'caption', style: { color: 'text.disabled' } }}
                                />
                                <ActiveChip status={item.account.active ? 'Active' : 'Inactive'}/>
                            </DataSetItem>
                            {index < accounts.length - 1 && <DataDivider />}
                        </Fragment>
                    )))}
                </DataSet>
            </TaskContainer>
        </Grid>
    );
};

export default ProfileAccountsBox;